import React, { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import BusinessDetailHorizontalTab from "./businessDetailHorizontalTab";
import { useDispatch } from "react-redux";
import { UserContext } from "../../auth/auth-context";
import { setSelectedBusiness } from "../../../redux/actions/businessActions";
import { usePermissions } from "../../../hooks/usePermissions";
import { useSelectedBusiness } from "../../../redux/store";
const BusinessListVerticalTab: React.FC = () => {
  const dispatch = useDispatch();
  const userContext = useContext(UserContext);
  const token = userContext.providerUser;
  const [isDisabled, setIsDisabled] = useState(true);
  const { canEditBusiness } = usePermissions();
  const selectedBusiness = useSelectedBusiness();

  useEffect(() => {
    const canEdit = canEditBusiness();
    if (canEdit) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [canEditBusiness]);

  useEffect(() => {
    if (
      token?.defaultBusinessId &&
      (!selectedBusiness ||
        Number(selectedBusiness.businessBasic.id) !==
          Number(token.defaultBusinessId))
    ) {
      dispatch(setSelectedBusiness(token.defaultBusinessId));
    }
  }, [token?.defaultBusinessId, selectedBusiness, dispatch]);

  return (
    <>
      <div className="content-header">
        <Typography
          variant="h5"
          sx={{ marginBottom: 2, textAlign: "left", marginLeft: 0 }}
        >
          Business Profile
        </Typography>
      </div>
      <Box
        sx={{
          paddingLeft: { xs: "16px", sm: "24px" }, // Add padding on small devices
          paddingRight: { xs: "16px", sm: "24px" }, // Prevent content touching the edges
          width: "100%", // Ensure full width of the container
        }}
      >
        <BusinessDetailHorizontalTab isDisabled={isDisabled || false} />
      </Box>
    </>
  );
};

export default BusinessListVerticalTab;
